import React from 'react'
import { ResponsiveBar } from '@nivo/bar'
import { useCompare } from 'CRM/hooks/Dashboard/GetCompare'
import { ToolTipDate, ToolTipWrapper } from './styles';
import {useIsMobile} from "./IsMobile";
import {MobileChartCalVW} from "./ChartCalVW";

export const LastMonthChart = () => {
  const { compareData } = useCompare();
  const IsMobile = useIsMobile();

  return (
    <div style={{width: '90%', height: 150}}>
         <ResponsiveBar
            data={
            [
                {
                    key: '지난달 금액',
                    result: parseFloat(compareData?.prevAmount)
                },
                {
                    key: '지난달 건수',
                    result: parseFloat(compareData?.prevCount) * 100000
                },
            ]
            }
            keys={[
                'result',
            ]}
            tooltip={(data) => {
              return (
                <ToolTipWrapper IsMobile={IsMobile}>
                  <ToolTipDate IsMobile={IsMobile}>
                    <span style={{color: data?.color}}>{data?.data?.key}</span>: {data?.data?.key == '지난달 건수' ? (data?.data?.result / 100000)?.toLocaleString() : (data?.data?.result)?.toLocaleString()} {data?.data?.key == '지난달 건수' ? '건' : '원'}
                  </ToolTipDate>
                </ToolTipWrapper>
              )
            }}
            indexBy="key"
            margin={{ top: 0, right: 0, bottom: 0, left: IsMobile ? MobileChartCalVW(500) : 100 }}
            padding={IsMobile ? MobileChartCalVW(3) : 0.2}
            innerPadding={IsMobile ? MobileChartCalVW(2) : 2}
            groupMode="grouped"
            layout="horizontal"
            valueScale={{ type: 'linear' }}
            indexScale={{ type: 'band', round: true }}
            colors={'#1f77b4'}
            axisTop={null}
            axisRight={null}
            axisBottom={{}}
            axisLeft={{}}
            labelSkipWidth={IsMobile ? MobileChartCalVW(5000) :  5000}
            labelSkipHeight={IsMobile ? MobileChartCalVW(10) : 10}
            labelTextColor={{
                from: 'color',
                modifiers: [
                    [
                        'darker',
                        1.6
                    ]
                ]
            }}
            legends={[]}
            role="application"
            ariaLabel="Nivo bar chart demo"
            barAriaLabel={e=>e.id+": "+e.formattedValue+" in country: "+e.indexValue}
        />
    </div>
   
  )
}

export default React.memo(LastMonthChart);